import React from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="ap-hero">
        <div className="ap-hero-content">
          <h1>About Us</h1>
          <p>
            Discover DAMA Tunisia, dedicated to advancing data management
            excellence through resources, events, and a supportive community
            of professionals.
          </p>
        </div>
      </section>

      {/* ===== SIGNPOSTS — texte gauche + boutons droite ===== */}
      <section className="ap-signposts-section">
        <div className="ap-container">
          <div className="ap-signposts-inner">

            {/* Texte à gauche */}
            <p className="ap-signposts-title">
              <strong>To learn more about DAMA Tunisia's operations and offerings, click on the signposts below.</strong>
            </p>

            {/* Boutons empilés à droite */}
            <div className="ap-signposts">
              <Link to="/chapters-board" className="ap-signpost ap-sp-1">
                DAMA Tunisia Committee
              </Link>
              <a href="#contact" className="ap-signpost ap-sp-4">
                Contact Us
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* ===== ABOUT DAMA TUNISIA ===== */}
      <section className="ap-section">
        <div className="ap-container">
          <h2>About DAMA Tunisia</h2>
          <p>
            At <strong>DAMA Tunisia</strong>, we champion the value of data management
            and support a growing community of professionals across Tunisia. We provide{' '}
            <strong>resources, networking opportunities, and expert-led insights</strong>{' '}
            to help our members manage data as a strategic asset.
          </p>
          <div className="ap-cta-row">
            <Link to="/membership" className="ap-cta-btn">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="ap-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <a href="#contact" className="ap-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </a>
          </div>
        </div>
      </section>

      {/* ===== WHY DATA MATTERS ===== */}
      <section className="ap-section ap-gray">
        <div className="ap-container">
          <h2>Why Data Matters</h2>
          <p>Data is the lifeblood of every organisation. When managed effectively, it fuels smarter decisions, deeper insights, and meaningful actions.</p>
          <p>Treating data as a strategic asset unlocks its true value, enabling organisations to drive innovation, efficiency, and success.</p>
          <p>DAMA Tunisia empowers data professionals to harness this potential through education, best practices, and a strong community network.</p>
          <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
            <Link to="/membership" className="ap-join-btn">Join DAMA Tunisia and Advance Your Career!</Link>
          </div>
        </div>
      </section>

      {/* ===== WHO WE ARE ===== */}
      <section className="ap-section">
        <div className="ap-container">
          <h2>Who We Are</h2>
          <p>DAMA Tunisia is the Tunisian chapter of the Data Management Association (DAMA), a global network of data management professionals.</p>
          <p>As a local chapter, we bring together experts and practitioners to advance the discipline of data management, providing support, education, and opportunities for collaboration across industries.</p>
          <p>Through our community-driven initiatives, we help professionals develop the skills and knowledge needed to succeed in today's evolving data landscape.</p>
        </div>
      </section>

      {/* ===== OUR MISSION ===== */}
      <section className="ap-section ap-gray">
        <div className="ap-container">
          <h2>Our Mission</h2>
          <p>
            Our mission is to nurture a community of data professionals in Tunisia who champion the value of data management. We achieve this through{' '}
            <strong>education, networking, and best practice guidance</strong>, ensuring that data professionals across Tunisia have access to the tools, resources, and knowledge they need.
          </p>
        </div>
      </section>

      {/* ===== HOW WE CAN HELP ===== */}
      <section className="ap-section">
        <div className="ap-container">
          <h2>How We Can Help You</h2>
          <p>DAMA Tunisia supports data professionals by offering expert mentoring, training, and access to a thriving community of peers.</p>
          <ul className="ap-help-list">
            <li><strong>Mentorship Programme</strong> – Connect with experienced professionals for guidance and career development.</li>
            <li><strong>Training & Certification</strong> – Access CDMP certification prep and exclusive discounts on training courses.</li>
            <li><strong>Community & Networking</strong> – Join events, webinars, and regional groups to engage with fellow data professionals.</li>
            <li><strong>Educational Resources</strong> – Gain insights from the DMBoK®, industry articles, and recorded webinars.</li>
          </ul>
          <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
            <Link to="/membership" className="ap-join-btn">Join DAMA Tunisia Today</Link>
          </div>
        </div>
      </section>

      {/* ===== GET INVOLVED ===== */}
      <section className="ap-section ap-gray" id="contact">
        <div className="ap-container">
          <h2>Get Involved</h2>
          <p>DAMA Tunisia is here to support your journey in data management. Whether you're looking for professional development, networking opportunities, or access to industry best practices, we encourage you to explore the resources below.</p>
          <div className="ap-get-involved">
            <Link to="/membership" className="ap-involved-btn">Become a Member</Link>
            <Link to="/learning" className="ap-involved-btn">CDMP Accreditation</Link>
            <Link to="/events" className="ap-involved-btn">Upcoming Events</Link>
          </div>
        </div>
      </section>

      {/* ===== BOTTOM CTA ===== */}
      <section className="ap-cta-section">
        <div className="ap-container">
          <div className="ap-cta-grid">
            <Link to="/membership" className="ap-cta-btn-bottom">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="ap-cta-btn-bottom">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <a href="#contact" className="ap-cta-btn-bottom">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;